/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getDocumentTypes: (typeUser = "DRIVER", params = {}) => {
    const normalizedTypeUser = String(typeUser || "DRIVER").toUpperCase();
    const isUserBased = normalizedTypeUser === "USER" || normalizedTypeUser === "CORPORATE";
    const endpoint = isUserBased
      ? API_ENDPOINTS.USER_DOCUMENTS_TYPE
      : API_ENDPOINTS.DRIVER_DOCUMENTS_TYPE;

    return axios.get(endpoint, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
      params: isUserBased ? { userType: normalizedTypeUser, ...params } : params,
    });
  },
  createDocumentType: (data) => {
    return axios.post(API_ENDPOINTS.DRIVER_DOCUMENT_TYPES, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  updateDocumentType: (id, data) => {
    return axios.put(`${API_ENDPOINTS.DRIVER_DOCUMENT_TYPES}/${id}`, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  deleteDocumentType: (id) => {
    return axios.delete(`${API_ENDPOINTS.DRIVER_DOCUMENT_TYPES}/${id}`, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  getMasterValues: () => {
    return axios.get(API_ENDPOINTS.GET_SITE_SETTINGS, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug":"default"
      },
    });
  },
  sitelogoupload: (data) => {
      //console.log("userId:", userID);
      //console.log("image:", image);
      return axios.put(API_ENDPOINTS.SITE_IMAGE_UPLOAD+'/',data, {
        headers: {
          isAuthRequired: true,
          "Content-Type": "multipart/form-data",
        },
      });
    },
  updateMasterValues: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_SITE_SETTINGS, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  getProfileDetails: (data) => {
    return axios.post(API_ENDPOINTS.PROFILE, data, {
      headers: { 
        isAuthRequired: true, 
        "Content-Type": "application/json",
        "x-tenant-slug":"default"
       },
    });
  },
  updateProfileDetails: (data) => {
    //console.log('data-->',data.userID);
    return axios.put(API_ENDPOINTS.UPDATE_PROFILE+'/'+data.userID, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },
  updatePassword: (data) => {
    //console.log('data-->',data.userID);
    return axios.put(API_ENDPOINTS.UPDATE_PASSWORD+'/'+data.userID, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
    });
  },
  updateAppState: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_APP_STATE, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
    });
  },
  updateSmsState: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_SMS_STATE, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
    });
  },

  //

  getPaymentSettings: () => {
    return axios.get(API_ENDPOINTS.GET_PAYMENT_SETTINGS, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },

  updatePaymentSettings: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_PAYMENT_SETTINGS, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },

  getPlatformSettings: () => {
    return axios.get(API_ENDPOINTS.GET_PLATFORM_SETTINGS, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },

  updatePlatformSettings: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_PLATFORM_SETTINGS, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },

  getuserRewardformSettings: () => {
    return axios.get(API_ENDPOINTS.GET_USER_REWARD_SETTINGS, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },

  updateuserRewardformSettings: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_USER_REWARD_SETTINGS, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },

  getBusinessSettings: () => {
    return axios.get(API_ENDPOINTS.GET_BUSINESS_SETTINGS, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },

  updateBusinessSettings: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_BUSINESS_SETTINGS, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },

  getMetuaaProfile: () => {
    return axios.get(API_ENDPOINTS.GET_METUAA_PROFILE, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },

  createMetuaaProfile: (data) => {
    return axios.post(API_ENDPOINTS.CREATE_METUAA_PROFILE, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },

  updateMetuaaProfile: (id, data) => {
    return axios.put(`${API_ENDPOINTS.UPDATE_METUAA_PROFILE}/${id}`, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },

  deleteMetuaaProfile: (id) => {
    return axios.delete(`${API_ENDPOINTS.DELETE_METUAA_PROFILE}/${id}`, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },

  getUserDetails: () => {
    return axios.get(API_ENDPOINTS.GET_USER_DETAILS, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },

  changeUserPassword: (id, data) => {
    const url = `${API_ENDPOINTS.UPDATE_USER_PASSWORD}/${id}`;
    return axios.put(url, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },

  getLegalSettings: () => {
    return axios.get(API_ENDPOINTS.GET_LEGAL_SETTINGS, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },

  updateLegalSettings: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_LEGAL_SETTINGS, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },

  downloadDriverContract: (userId) => {
    const url = `${API_ENDPOINTS.DOWNLOAD_LEGAL_CONTRACT}/${userId}/download`;
    return axios.get(url, {
      headers: {
        isAuthRequired: true,
        "x-tenant-slug": "default",
      },
      responseType: "blob",
    });
  },

  getprivacySettings: () => {
    return axios.get(API_ENDPOINTS.GET_PRIVACY_SETTINGS, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },

  updateprivacySettings: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_PRIVACY_SETTINGS, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },
};
